import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import { ResourceOriginHttpRepository, ResourceOriginDummyRepository } from './infrastructure/repository';

// Application
import { SearchResourcesOriginsQuery } from './application/queries';

// Domain
import { ResourceOriginRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupResourceOrigin(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.CATALOG_ALLIANZ_RESOURCE_ORIGIN_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<ResourceOriginRepository>(TYPES.CATALOG_ALLIANZ_RESOURCE_ORIGIN_REPOSITORY)
    .to(
      withDummies
        ? ResourceOriginDummyRepository
        : ResourceOriginHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<SearchResourcesOriginsQuery>(TYPES.SEARCH_CATALOG_ALLIANZ_RESOURCE_ORIGIN_QUERY)
    .to(SearchResourcesOriginsQuery)
    .inSingletonScope();
}
